import { useCallback } from 'react';
import { pick, prop } from 'ramda';
import { useAppSelector, useUserSelector } from 'js/store/hooks';

import * as Types from '../types';
import { LEFT_CURRENCY_SYMBOL_POSITION } from '../constants';

export const useGetConfig = () => {
    const userLocale = useUserSelector(prop('lang'));
    const { numberSeparator, currencySymbolPosition, localeSeparatorCurrencyMapping } = useAppSelector(pick([
        'numberSeparator', 'currencySymbolPosition', 'localeSeparatorCurrencyMapping'
    ]));

    return useCallback((locale?: string): Types.IFormatterConfig => {
        const dataPerLocale = localeSeparatorCurrencyMapping.find((item) => item.locale === (locale?.replace(/-/, '_') || userLocale));
        const numberSeparatorParsed = dataPerLocale?.numberSeparator || numberSeparator;
        const currencySymbolPositionParsed = dataPerLocale?.currencySymbolPosition || currencySymbolPosition;

        return {
            number: {
                precision: null,
                thSeparator: numberSeparatorParsed[1],
                decSeparator: numberSeparatorParsed[5]
            },
            currency: {
                precision: 2,
                symbolAtTheLeft: currencySymbolPositionParsed === LEFT_CURRENCY_SYMBOL_POSITION,
                originalCurrencyCode: false
            }
        };
    }, [userLocale, numberSeparator, currencySymbolPosition, localeSeparatorCurrencyMapping]);
};
